<template>
  <div class="modal fade" id="costumModalprofil" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
    aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
    style="background: rgba(240, 248, 255, 0.1);">
    <div class="modal-dialog modal-fullscreen" style="width: 98vw;height: 98%;">
      <div class="modal-content" style="height: auto;min-width: 95vw; min-height: 98%;">
        <div class="modal-header">
          <h4 class="modal-title">Profil {{ namauser }}</h4>
          <button type="button" class="close" aria-label="Close" @click="tutupmodal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-justify" style="height: auto;min-width: 95vw; min-height: 98%;">
          <p>
          <div class="row">
            <div class="col-sm-12">
              <label>Nama</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                </div>
                <input type="text" class="form-control form-control-sm" id="namauser" name="namauser"
                  placeholder="Nama User" v-model="namauser" readonly>
              </div>
            </div>
            <div class="col-sm-12">
              <label>Username</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="far fa-address-card"></i></span>
                </div>
                <input type="text" class="form-control form-control-sm" id="username" name="username"
                  placeholder="Username" v-model="username">
                <input type="hidden" class="form-control form-control-sm" id="username_tmp" name="username_tmp"
                  placeholder="Username" v-model="username_tmp">
              </div>
            </div>
            <div class="col-sm-12">
              <label>Password Lama</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input type="password" class="form-control form-control-sm" id="password" name="password"
                  placeholder="Password Lama" v-model="password">
              </div>
            </div>
            <div class="col-sm-12">
              <label>Password Baru</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input type="password" class="form-control form-control-sm" id="passwordbaru" name="passwordbaru"
                  placeholder="Password Baru" v-model="passwordbaru">
              </div>
            </div>
            <!--SERTIFIKAT GAMBAR 1-->
            <div class="col-sm-12" v-if="mode == 'edit'">
              <label>Foto<small class="text-info"> (*jpg)</small>
              </label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="far fa-file-image"></i></span>
                </div>
                <input type="file" class="form-control form-control-sm" id="fileToUploadpic" name="fileToUploadpic"
                  placeholder="fileToUpload" style="font-size: smaller;" accept="image/*">
                <input type="hidden" class="form-control form-control-sm" id="pic" name="pic"
                  placeholder="File Beranda">
              </div>
            </div>
            <div class="col-sm-12" v-if="mode == 'edit'">
              <label>Opsi</label>
              <div class="row">
                <div class="col-sm-9">
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                      style="width:0%" id="persennyapic">
                      <span id="tulisanpersenpic">0%</span>
                    </div>
                  </div>
                  <br>
                  <span class="text-success" id="suksesnyapic"></span>
                </div>
                <div class="col-sm-3 text-center">
                  <button type="button" class="btn btn-warning btn-sm lebar text-white"
                    @click="uploadfile('pic', 'image/*')">Upload
                    File</button>
                  <button type="button" class="btn btn-danger btn-sm lebar" @click="clearfilepeta('pic')">Hapus
                    File</button>
                </div>
              </div>
            </div>
            <!--SERTIFIKAT GAMBAR 1 END-->
          </div>
          </p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-success3 btn-sm lebar2 text-white" @click="UpdateProfil()"><i
              class="fas fa-user-edit"></i>
            Ubah</button>
          <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" @click="tutupmodal()"> <i
              class="far fa-times-circle"></i>
            Batal</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-dark" style="background-color: #3a4767;">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link wow fadeInDown" data-widget="pushmenu" href="#" role="button" style="font-size: large;">
          <i class="fas fa-align-left" style="color: aliceblue;"></i>
        </a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto wow fadeInDown" id="navbar" style="position: fixed;right: 20px;">
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-item" data-toggle="dropdown" href="#">
          <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle" style="height: 50px !important;">
          <b class="text-white">{{ namauser }} <i class="fas fa-angle-down"></i></b>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="javascript:void(0)" class="dropdown-item" @click="UbahProfil()">
            <i class="fas fa-user mr-2"></i> Profil
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item" v-on:click="logoutAct">
            <i class="fas fa-sign-out-alt mr-2"></i> Logout
          </a>
        </div>
      </li>
      <li class="nav-item dropdown" style="padding-left: 20px !important;" v-if="jumlahpesan > 0">
        <a class="nav-link" data-toggle="dropdown" href="javascript:void(0)">
          <i class="far fa-bell"></i>
          <span class="badge badge-warning navbar-badge" style="font-size: smaller !important;">{{ jumlahpesan }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header" style="font-size: smaller !important;">Notifikasi</span>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" style="font-size: x-small !important;"
            v-if="jumlahagenda > 0" @click="bukapesan()">
            <i class="fas fa-envelope mr-2"></i> {{ jumlahagenda }} agenda baru
          </a>
          <a href="javascript:void(0)" class="dropdown-item" style="font-size: x-small !important;"
            v-for="(datalist, urutlist) in komentar" :key="urutlist"
            @click="bukakomentar(datalist.id_user, datalist.id_event)">
            <i class="fas fa-envelope mr-2"></i> {{ datalist.nama }} <br></br>menulis komentar di agenda<br></br>{{
              datalist.agenda }}
          </a>
        </div>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
  components: {
    swal
  },
  data() {
    return {
      tahun: new Date().getFullYear(),
      kodepengguna: JSON.parse(localStorage.getItem("isistem")),
      iduser: JSON.parse(localStorage.getItem("usistem")),
      namauser: JSON.parse(localStorage.getItem("nmusistem")),
      kodeiduser: JSON.parse(localStorage.getItem("tokensistem")),
      imgsistem: JSON.parse(localStorage.getItem("imgsistem")),
      username: '',
      username_tmp: '',
      password: '',
      passwordbaru: '',
      img: JSON.parse(localStorage.getItem("imgsistem")),
      folder: process.env.VUE_APP_URL_API + 'parastapainnovationgetuser-Gambar?f=' + JSON.parse(localStorage.getItem("imgsistem")),
      project_id: process.env.VUE_APP_PROJECT_ID,
      jumlahpesan: 0,
      jumlahagenda: 0,
      jumlahcomment: 0,
      idnya: '',
      komentar: [],
      datamaster: [],
      mode: '',
    };
  },
  methods: {
    getOtentifikasi() {
      const mainAPIUser = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("tokensistem"),
        },
      });

      mainAPIUser.get("parastapainnovation-GetDataUserName?kduser=" + localStorage.getItem("usistem") + "&level=" + localStorage.getItem("lsistem") + "&project_id=" + this.project_id).then(
        Res => {
          if (Res.data.response == 'error') {
            //alert(localStorage.getItem("tokensistem"));
            //alert(JSON.stringify(Res.data));
            this.ClearlocalStorage();
            return false;
          }
          else {
            //alert(JSON.stringify(Res.data));
            this.username = Res.data.content.data[0].username;
            this.username_tmp = Res.data.content.data[0].username;
          }
        }
      ).catch(
        error => {
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: error,
          });
          $('.swal2-container').css("z-index", '999999');
        }
      )
    },
    tutupmodal() {
      this.mode = '';
      $('#costumModalprofil').modal('hide');
    },
    clearfilepeta(idnya) {
      if (document.getElementById(idnya).value == '') {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: 'File Tidak Tersedia',
        });
        $('.swal2-container').css("z-index", '999999');
        return false;
      }

      var fd = new FormData();
      fd.append("folderToUpload", idnya);
      fd.append("filenya", document.getElementById(idnya).value);
      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          "Content-Type": "form-data",
          Authorization: "Bearer " + localStorage.getItem("tokensistem"),
        },
      });
      mainAPI.post("parastapainnovationimg-FilesDeleted", fd).then(
        Response => {
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: Response.data.message,
          });
          $('.swal2-container').css("z-index", '999999');
        }
      ).catch(function (error) {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: error
        });
        $('.swal2-container').css("z-index", '999999');
      }
      )

      document.getElementById('fileToUpload' + idnya).value = '';
      document.getElementById(idnya).value = '';
      document.getElementById('persennya' + idnya).style.width = "0%";
      document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
      document.getElementById('suksesnya' + idnya).innerHTML = '';
      return false;
    },
    uploadfile(idnya, tipenya) {
      var elmnt = document.getElementById("fileToUpload" + idnya);
      try {
        var namanya = elmnt.files[0].name;
        //alert(elmnt.files[0]['type'].toUpperCase());
        if (tipenya == 'image/*') {
          if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
            document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
            return;
          }
        }
        else {
          if (elmnt.files[0]['type'] != tipenya) {
            document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
            return;
          }
        }
      } catch (error) {
        document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
        return;
      }
      var fd = new FormData();
      fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
      fd.append("folderToUpload", idnya);
      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          "Content-Type": "form-data",
          Authorization: "Bearer " + localStorage.getItem("tokensistem"),
        },
      });
      mainAPI.post("parastapainnovationimg-FilesUpload", fd, {
        onUploadProgress: function (uploadEvent) {
          document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
          document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
        }
      }).then(
        function (res) {
          document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
          if (res.data.filename != undefined) {
            document.getElementById(idnya).value = res.data.filename;
          }
        }
      ).catch(function (e) {
        document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
        document.getElementById(idnya).value = '';
        console.log(e);
      }
      )
    },
    bukapesan() {
      window.location.replace("/Inbox");
    },
    async bukakomentar(id_user, id_event) {
      //alert(this.kodepengguna);
      //alert(id_user);
      //alert(id_event);
      this.idnya = '';
      this.halamanloading = true;
      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("tokensistem"),
        },
      });
      var random = Math.random();
      await mainAPI.get("parastapainnovation_inbox-CekUndangan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + id_user + "&id_event=" + id_event).then(
        Response => {
          this.datapesan = Response.data.message;
          this.komentar = [];
          if (this.datapesan == 'data diketemukan') {
            this.idnya = Response.data.content.data[0].id;
            //alert(this.idnya);
            var adicek = this.idnya + "_" + id_user;
            const data = { kode: this.idnya, project_id: this.project_id, readby: JSON.parse(localStorage.getItem("isistem")) }
            const mainAPIku = axios.create({
              baseURL: process.env.VUE_APP_URL_API,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                "Content-Type": "application/x-www-form-urlencoded",
              },
            });
            mainAPIku.post("parastapainnovation_inbox-Open", data).then(
              Response => {
                //alert(adicek);
                if (Response.data.response == 'error') {
                  swal.fire('Peringatan', Response.data.message, 'error');
                }
                else {

                  var bytes = encodeURIComponent(CryptoJS.AES.encrypt(adicek, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                  window.location.replace("/ProsesInbox/" + bytes);
                }
              }
            ).catch(
              error => {
                console.log(error);
                swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
              }
            )
          }
          else {
            this.idnya = '';
          }
          this.halamanloading = false;
        }
      ).catch(error => {
        //console.log(error);
        this.idnya = '';
        //this.ClearlocalStorage();
        this.halamanloading = false;
      });
    },
    UbahProfil() {
      this.mode = 'edit';
      $('#costumModalprofil').modal('show');
    },
    UpdateProfil() {
      if (this.username == '') {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: 'Isikan username..',
        });
        $('.swal2-container').css("z-index", '999999');
        return false;
      }
      if (this.password == '') {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: 'Isikan password..',
        });
        $('.swal2-container').css("z-index", '999999');
        return false;
      }
      if (this.passwordbaru == '') {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: 'Isikan password baru..',
        });
        $('.swal2-container').css("z-index", '999999');
        return false;
      }
      swal.fire({
        title: "Konfirmasi",
        text: "Yakin Hendak Ubah Kata Sandi / Password?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Batal",
        confirmButtonColor: "#3a4767",
        cancelButtonColor: "#ffaa05",
        confirmButtonText: "Ubah"
      }).then((result) => {
        if (result.isConfirmed) {
          //alert(document.getElementById('img').value);
          //return false;
          const data = {
            kduser: JSON.parse(localStorage.getItem("tokensistem")),
            username: this.username,
            username_tmp: this.username_tmp,
            passwordlama: this.password,
            passwordbaru: this.passwordbaru,
            project_id: this.project_id,
            foto: document.getElementById('pic').value,
          };
          const mainAPI = axios.create({
            baseURL: process.env.VUE_APP_URL_API,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("tokensistem"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
          mainAPI.post("parastapainnovation-ChangeUserPassword", data).then(
            Response => {
              if (Response.data.response == 'error') {
                swal.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000
                }).fire({
                  icon: 'warning',
                  title: Response.data.message,
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
              }
              else {
                swal.fire({
                  title: "Informasi",
                  text: "Profil Pengguna Telah Dirubah!",
                  icon: "success"
                }).then(function () {
                  localStorage.removeItem('tokensistem');
                  localStorage.removeItem('isistem');
                  localStorage.removeItem('usistem');
                  localStorage.removeItem('lsistem');
                  localStorage.removeItem('inssistem');
                  localStorage.removeItem('rlsistem');
                  localStorage.removeItem('nmlsistem');
                  localStorage.removeItem('emlsistem');
                  localStorage.removeItem('nmusistem');
                  localStorage.removeItem('orsistem');
                  localStorage.removeItem('nmorsistem');
                  localStorage.removeItem('bdlsistem');
                  localStorage.removeItem('nmbdlsistem');
                  localStorage.removeItem('sbdsistem');
                  localStorage.removeItem('nmsbdsistem');
                  localStorage.removeItem('jbtsistem');
                  localStorage.removeItem('loksistem');
                  localStorage.removeItem('nmloksistem');
                  localStorage.removeItem('imgsistem');
                  localStorage.removeItem('settingabsensistem');
                  localStorage.removeItem('tsistem');
                  window.location.replace("/Login");
                });
                $('.swal2-container').css("z-index", '999999');
              }
            }
          ).catch(
            error => {
              swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                icon: 'warning',
                title: error,
              });
              $('.swal2-container').css("z-index", '999999');
            }
          )
        }
      });
      $('.swal2-container').css("z-index", '999999');
      return false;
    },
    async logoutAct() {
      swal.fire({
        title: "Konfirmasi",
        text: "Yakin Hendak Keluar Aplikasi?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Batal",
        confirmButtonColor: "#3a4767",
        cancelButtonColor: "#ffaa05",
        confirmButtonText: "Keluar"
      }).then((result) => {
        if (result.isConfirmed) {
          this.ClearlocalStorage();
        }
      });

      return false;
    },
    async ambildata() {
      this.halamanloading = true;
      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("tokensistem"),
        },
      });
      var random = Math.random();
      await mainAPI.get("parastapainnovation_event-Count?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.kodepengguna).then(
        Response => {
          this.datapesan = Response.data.message;
          this.komentar = [];
          if (this.datapesan == 'data diketemukan') {
            this.datamaster = [];
            this.datamaster = Response.data.content.data;
            this.jumlahpesan = Response.data.content.data[0].jumlah;
            this.jumlahagenda = Response.data.content.data[0].jumlahagenda;
            this.jumlahcomment = Response.data.content.data[0].jumlahcomment;
            this.komentar = Response.data.content.data[0].komentar;
          }
          else {
            this.komentar = [];
            this.datamaster = [];
            this.jumlahpesan = 0;
            this.jumlahagenda = 0;
            this.jumlahcomment = 0;
          }
          this.halamanloading = false;
        }
      ).catch(error => {
        //console.log(error);
        this.komentar = [];
        this.datamaster = [];
        this.jumlahpesan = 0;
        this.jumlahagenda = 0;
        this.jumlahcomment = 0;
        //this.ClearlocalStorage();
        this.halamanloading = false;
      });
    },
  },
  mounted() {
    this.getOtentifikasi();
    this.ambildata();
  },
}
</script>

<style></style>